import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import Button from "ds/components/Button";

import { useLayoutActions } from "../../hooks/useLayoutActions";
import { useLayoutHeading } from "../../hooks/useLayoutHeading";

type PageLayoutProps = {
  children: React.ReactNode;
  onCreate?: () => void;
  canCreateIntegrations?: boolean;
};

const PageLayout = ({ children, onCreate, canCreateIntegrations }: PageLayoutProps) => {
  useBreadcrumbs([
    {
      title: "Integrations",
      link: "/integrations",
    },
    {
      title: "ServiceNow",
    },
  ]);

  useLayoutHeading("ServiceNow");

  useLayoutActions(
    canCreateIntegrations ? (
      <Button variant="primary" onPress={onCreate}>
        Set up integration
      </Button>
    ) : undefined
  );

  return <>{children}</>;
};

export default PageLayout;
